import PropTypes from 'prop-types'
import { H3 } from './Heading'

export const ServiceCard = ({ title, description, icon }) => (
  <div className="bg-dark-tertiary rounded-lg p-6 border border-dark-border">
    {icon && <div className="mb-3 text-blue-400">{icon}</div>}
    <H3>{title}</H3>
    <p className="text-gray-300">{description}</p>
  </div>
)

ServiceCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node,
}

export default ServiceCard
